import { HttpRequest } from '../../utils';

export class BulkResult {
    status: number = 0;
    isError: boolean = false;
    isSuccess: boolean = true;
    isRecoverable: boolean = true;
    request: HttpRequest;
}
